export default __webpack_public_path__ + "static/media/SignUpPC.e0dc354e.svg";